import './gallery-item';
import './search-filters';
export default class ShoppingGalleryElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('shopping-gallery', ShoppingGalleryElement);